import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BillingBanner = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    axios.get(`${import.meta.env.VITE_IP}/bannerConfig`)
      .then((res) => setBanner(res.data))
      .catch(() => setBanner(null));
  }, []);

  if (!banner || !banner.enabled) return null;

  return (
    <div
      style={{
        background: '#dc2626',
        color: '#fff',
        textAlign: 'center',
        padding: '10px 16px',
        fontWeight: 700,
        fontSize: '14px',
        letterSpacing: '.01em',
        position: 'sticky',
        top: 0,
        zIndex: 2000,
      }}
    >
      {banner.message}
    </div>
  );
};

export default BillingBanner;
